var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    "aria-hidden": "true",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "green-ticks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component-green-tick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atom/Base-Icons/notification/positive/solid",
    fill: "#429448"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.164,0 0,7.164 0,16 C0,24.836 7.164,32 16,32 C24.836,32 32,24.836 32,16 C32,7.164 24.836,0 16,0 Z M24.674619,11.7049048 L14.594619,21.7849048 C14.3439524,22.0355714 14.0052857,22.1755714 13.6519524,22.1755714 C13.298619,22.1755714 12.958619,22.0355714 12.7092857,21.7849048 L8.10528571,17.1809048 C7.58395238,16.6595714 7.58395238,15.8169048 8.10528571,15.2955714 C8.62661905,14.7742381 9.46928571,14.7742381 9.99061905,15.2955714 L13.6519524,18.9569048 L22.7892857,9.81957143 C23.310619,9.2982381 24.1532857,9.2982381 24.674619,9.81957143 C25.1959524,10.3409048 25.1959524,11.1835714 24.674619,11.7049048 Z",
    id: "Shape-green-tick"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.3763d711dbab37c68aea86fc7c790e23.svg";
export { ForwardRef as ReactComponent };